module.exports = __webpack_public_path__ + "img/iPhone.de96b546.png";